<script lang="ts">
    import Date from 'hydria/components/Date.svelte'
    import LoadingPattern from 'hydria/components/LoadingPattern.svelte'
    import { gettext as _ } from 'hydria/services/gettext'
    import { humanizedNumber } from 'hydria/utils/humanized_numbers'

    import type { IServer } from './nsd_defs'

    interface Props {
        serviceType: 'dns' | 'service'
        loading: boolean
        server: IServer | undefined
    }

    let { serviceType, loading, server }: Props = $props()
</script>

<style>
    tr.active {
        background-color: #eee;
    }
</style>

<div class="card">
    <div class="card-title text-primary">{!loading && server ? server.name : '…'}</div>
    {#if loading !== false || server == null}
        <div class="card-body">
            <LoadingPattern pattern={['x', 'x', 'x', 'x']} />
        </div>
    {:else}
        <div class="card-body">
            <table class="table mb-0">
                <tbody>
                    <tr>
                        <th>En ligne :</th>
                        <td class:text-success={server.is_online} class:text-danger={!server.is_online}>{server.is_online ? 'Oui' : 'Non'}</td>

                        <th>Peut être en ligne :</th>
                        <td class:text-success={server.can_be_online} class:text-danger={!server.can_be_online}>{server.can_be_online ? 'Oui' : 'Non'}</td>
                    </tr>
                    <tr class:active={serviceType == 'dns'}>
                        <th>Dernier contact NSD :</th>
                        <td><Date value={server.last_dns_contact} format="h-table-s" /></td>
                        <th>Dernier ping NSD :</th>
                        <td>{humanizedNumber(server.last_dns_ping_us, 2, 1000, ['µs', 'ms', 's'], false, null)}</td>
                    </tr>
                    <tr class:active={serviceType == 'dns'}>
                        <th>Apdex NSD satisfait :</th>
                        <td>{humanizedNumber(server.dns_apdex_thresholds.satisfied_us, 2, 1000, ['µs', 'ms', 's'], false, null)}</td>
                        <th>Apdex NSD toléré :</th>
                        <td>{humanizedNumber(server.dns_apdex_thresholds.tolerated_us, 2, 1000, ['µs', 'ms', 's'], false, null)}</td>
                    </tr>
                    <tr class:active={serviceType == 'service'}>
                        <th>Dernier contact RPC :</th>
                        <td><Date value={server.last_service_contact} format="h-table-s" /></td>
                        <th>Dernier ping RPC :</th>
                        <td>{humanizedNumber(server.last_service_ping_us, 2, 1000, ['µs', 'ms', 's'], false, null)}</td>
                    </tr>
                    <tr class:active={serviceType == 'service'}>
                        <th>Apdex RPC satisfait :</th>
                        <td>{humanizedNumber(server.service_apdex_thresholds.satisfied_us, 2, 1000, ['µs', 'ms', 's'], false, null)}</td>
                        <th>Apdex RPC toléré :</th>
                        <td>{humanizedNumber(server.service_apdex_thresholds.tolerated_us, 2, 1000, ['µs', 'ms', 's'], false, null)}</td>
                    </tr>
                    <tr>
                        <th>Adresse DNS :</th>
                        <td>{server.dns_address}</td>
                        <th>Adresse RPC :</th>
                        <td>{server.zerorpc_address}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    {/if}
</div>
